const formatPhone = (num) => num.match(/\d/g)?.slice(0, num.length).map((c, i, l) => {
    const indexSeparator = num.length === 10 ? 6 : 7
    if (i === 0) return '(' + c;
    if (i === 2) return ')' + c;
    if (i === indexSeparator) return '-' + c;
    return c;
}).join('')

export { formatPhone }